import React from "react";
import HeaderLogged from "components/Header/HeaderLogged";
const SiteHeader = () => {
  return  <HeaderLogged />;
};

export default SiteHeader;
